export const selectedPosters = {
  id: "selected-posters",
  disciplines: "Poster",
  year: "21/25",
  project: "Selected Posters",
  initiatedAt: "Mixed",
  shortInitiatedAt: "Mixed",
  thumbnailUrl: "/assets/Selected_Posters/00.webp",
  description: "",
  credits: [],
  galleryItems: [
    {
      medias: [
        {
          type: "image",
          url: "/assets/Selected_Posters/01.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-four-lg portrait-media-din-a",
        },
        {
          type: "image",
          url: "/assets/Selected_Posters/02.webp",
          classNames:
            "start-one-sm span-four-sm start-five-lg span-four-lg portrait-media-din-a",
        },
        {
          type: "image",
          url: "/assets/Selected_Posters/03.webp",
          classNames:
            "start-one-sm span-four-sm start-nine-lg span-four-lg portrait-media-din-a",
        },
      ],
      description: {
        text: "",
        classNames:
          "start-one-sm span-four-sm start-one-lg span-twelve-lg spacing-bottom",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Selected_Posters/04.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-four-lg portrait-media-din-a",
        },
        {
          type: "image",
          url: "/assets/Selected_Posters/05.webp",
          classNames:
            "start-one-sm span-four-sm start-five-lg span-four-lg portrait-media-din-a",
        },
      ],
      description: {
        text: "",
        classNames:
          "start-one-sm span-four-sm start-one-lg span-twelve-lg spacing-bottom",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Selected_Posters/06.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-four-lg portrait-media-din-a",
        },
        {
          type: "image",
          url: "/assets/Selected_Posters/07.webp",
          classNames:
            "start-one-sm span-four-sm start-five-lg span-four-lg portrait-media-din-a",
        },
        {
          type: "image",
          url: "/assets/Selected_Posters/08.webp",
          classNames:
            "start-one-sm span-four-sm start-nine-lg span-four-lg portrait-media-din-a",
        },
      ],
      description: {
        text: "",
        classNames:
          "start-one-sm span-four-sm start-one-lg span-twelve-lg spacing-bottom",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Selected_Posters/09.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-four-lg portrait-media-din-a",
        },
        {
          type: "image",
          url: "/assets/Selected_Posters/10.webp",
          classNames:
            "start-one-sm span-four-sm start-five-lg span-four-lg portrait-media-din-a",
        },
        {
          type: "image",
          url: "/assets/Selected_Posters/11.webp",
          classNames:
            "start-one-sm span-four-sm start-nine-lg span-four-lg portrait-media-din-a",
        },
      ],
      description: {
        text: "",
        classNames:
          "start-one-sm span-four-sm start-one-lg span-twelve-lg spacing-bottom",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Selected_Posters/12.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-four-lg portrait-media-din-a",
        },
        {
          type: "image",
          url: "/assets/Selected_Posters/13.webp",
          classNames:
            "start-one-sm span-four-sm start-five-lg span-four-lg portrait-media-din-a",
        },
      ],
      description: {
        text: "",
        classNames:
          "start-one-sm span-four-sm start-one-lg span-twelve-lg spacing-bottom",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Selected_Posters/14.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-four-lg portrait-media-din-a",
        },
        {
          type: "image",
          url: "/assets/Selected_Posters/15.webp",
          classNames:
            "start-one-sm span-four-sm start-five-lg span-four-lg portrait-media-din-a",
        },
      ],
      description: {
        text: "",
        classNames:
          "start-one-sm span-four-sm start-one-lg span-twelve-lg spacing-bottom",
      },
    },
  ],
};
